export default {"src":"/_next/static/media/0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};